import { Box } from '@mui/material';
import { createContext, useContext, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

const Ctx = createContext<{
  slot: HTMLElement | null;
  setSlot: (el: HTMLElement | null) => void;
} | null>(null);

export function PageActionsProvider({ children }: { children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  return <Ctx.Provider value={{ slot, setSlot }}>{children}</Ctx.Provider>;
}

/** Empty AppBar slot that pages portal into. */
export function PageActionsSlot() {
  const ctx = useContext(Ctx);
  return <Box ref={ctx?.setSlot ?? undefined} sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'flex-end', flexWrap: 'wrap', flex: 1, minWidth: 0 }} />;
}

/** Renders children in the AppBar. */
export function PageActions({ children }: { children?: ReactNode }) {
  const ctx = useContext(Ctx);
  if (!ctx?.slot || children == null) return null;
  return createPortal(children, ctx.slot);
}
